import { getCurrentSubscriptionAPI } from "@client/clinic/getCurrentSubscriptionAPI";
import { dietitianKeys } from "@hooks/queries/dietitian/dietitianKeys";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const currentSubscriptionQuery = queryOptions({
  queryKey: dietitianKeys.currentSubscription(),
  queryFn: getCurrentSubscriptionAPI,
});

export const useFetchCurrentSubscriptionQuery = () => {
  const { data, ...rest } = useQuery(currentSubscriptionQuery);
  return { currentSubscription: data?.data, ...rest };
};
